const STORAGE_KEY = 'STORM_UI_THEME_MODE';
const BROADCAST_CHANNEL_KEY = 'STORM_UI_THEME_MODE_CHANNEL';

export { BROADCAST_CHANNEL_KEY as B, STORAGE_KEY as S };
//# sourceMappingURL=constants-BAsg3-1S.js.map
